import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '~/api/queryKeys';

import { fetchAnalyticsDataDownloads } from '../services/analytics.service';
import { EXPERIMENT_ANALYTICS_READ_OPTIONS } from '../utils/snapshot-read-retry';

/**
 * CSV report tiles for the category-mode "Detailed Data Downloads" grid.
 * Fetched from its own endpoint, independent of the selected category, so
 * the grid doesn't re-fetch or flicker on every dropdown change.
 */
export function useExperimentDataDownloads(experimentId: string, segment?: string) {
  return useQuery({
    queryKey: queryKeys.experiments.dataDownloads(experimentId, segment),
    queryFn: ({ signal }) => fetchAnalyticsDataDownloads(experimentId, segment, signal),
    // Snapshot-backed analytics read: shared retry/backoff policy. See helper.
    ...EXPERIMENT_ANALYTICS_READ_OPTIONS,
  });
}
